module.exports = __webpack_public_path__ + "71af96a541b597d135afaa4d3bfc7527.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-vocabulary.png
// module id = 2984
// module chunks = 0